import wx from 'weixin-js-sdk'

export const MESSAGE_TYPE = {
  SHOW_POSTER: 1,
  NAVIGATE_TO: 2,
  NAVIGATE_BACK: 3,
  SWITCH_TAB: 4,
  TITLE: 5,
  SHARE_MESSAGE: 6 
}

const LY = {  
  clickQRCode(options) {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: MESSAGE_TYPE.SHOW_POSTER,
        url: options.url,
        title: options.title,
        tips: options.tips
      }))        
    }
    if (wx && wx.previewImage) {
      this.onClickImage(options.url, options.urls || null)
    }
  },
  // 微信打开图片
  onClickImage(url, urls) {
    if (wx) {
      wx.previewImage({
        current: url,
        urls: urls || [url]
      })
    }    
  },
  // 设置微信分享
  setWechatShare(options) {
    wx.ready(function () {
      wx.updateAppMessageShareData({ 
        title: options.title, // 分享标题
        desc: options.desc, // 分享描述
        link: options.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: options.imgUrl, // 分享图标
        success: function () {
          // 设置成功          
        }
      })
      wx.updateTimelineShareData({ 
        title: options.title, // 分享标题
        link: options.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: options.imgUrl, // 分享图标
        success: function () {
          // 设置成功
        }
      })
    })
  }
}

export default LY


// WEBPACK FOOTER //
// ./src/utils/liuya-js-sdk.js